import { Input } from './Input';
import CheckIcon from '@/assets/icons/common/check.svg';
import { restoreLastValidEmail, isEmailValid } from '@/utils/email';
import { useContext, useEffect, useRef, useState } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useTranslate } from '@/hooks/useTranslate';
import { useLatestRef } from '@/hooks/useLatestRef';

export const Email = () => {
  const { t } = useTranslate();
  const [hideErrorMessage, setHideErrorMessage] = useState(true);
  const context = useContext(CheckoutContext);
  const {
    customer,
    actions: { setCustomerEmail },
  } = context;
  const email = customer?.email ?? '';
  const lastValidEmailRef = useRef(isEmailValid(email) ? email : '');
  const restoreRef = useLatestRef({ email, setCustomerEmail });

  useEffect(() => {
    if (isEmailValid(email)) {
      lastValidEmailRef.current = email;
    }
  }, [email]);

  useEffect(() => () => restoreLastValidEmail(restoreRef.current, lastValidEmailRef.current), [restoreRef]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCustomerEmail(e.target.value);
    setHideErrorMessage(true);
  };

  const handleBlur = () => {
    setHideErrorMessage(isEmailValid(email));
  };

  return (
    <Input
      type="email"
      inputMode="email"
      autoComplete="email"
      placeholder={t('emailAddress')}
      value={email}
      onChange={handleChange}
      onBlur={handleBlur}
      error={hideErrorMessage ? undefined : t('fieldErrors.invalidEmail')}
      className="w-full text-base"
      maxLength={254}
      leftIcon="fa-light fa-envelope"
      rightIcon={isEmailValid(email) ? () => <img src={CheckIcon} className="w-5 h-5" /> : undefined}
    />
  );
};
